import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { EstablishmentTechnicalProfessionalValidationSchema } from '@/features/maintenance/establishmentTechnicalProfessionals/schemas/create.schema'
import { useMutation } from '@tanstack/react-query'

interface UseUpdateEstablishmentTechnicalProfessionalProps {
  id: string
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

export const useUpdateEstablishmentTechnicalProfessional = ({
  id,
  onSuccess,
  onError,
}: UseUpdateEstablishmentTechnicalProfessionalProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateEstablishmentTechnicalProfessional'],
    mutationFn: async (form: EstablishmentTechnicalProfessionalValidationSchema) =>
      privateAxios.put(`/maintenance/establishment_technical_professionals/${id}`, form),
    onSuccess,
    onError,
  })
}
